export const NOTHING = null;
export const PARAMETRES_AFFIXE2 = {
  autoriserAuthentificationAffixe1: {
    key: 'AutoriserAuthentificationAffixe1',
  },
  activationYield: {
    key: 'ActivationYield',
  },
};
export const DOMAINE = 'Portail';



// WEBPACK FOOTER //
// ./src/configuration/paramsAffixe2.js